import { v4 as uuidv4 } from "uuid";

export const SidebarData = [
  {
    id: uuidv4(),
    title: "Home",
    path: "/",
    cName: "nav-text",
  },
  {
    id: uuidv4(),
    title: "About",
    path: "/about",
    cName: "nav-text",
  },
  {
    id: uuidv4(),
    title: "Projects",
    path: "/projects",
    cName: "nav-text",
  },
  {
    id: uuidv4(),
    title: "Contacts",
    path: "/contacts",
    cName: "nav-text",
  },
];
